// Below `lg` the aside already sits flush with the header's right edge, so its
// own right padding is dead space; dropping it hands the width to the reading
// column beside it.
.root {
	@media (max-width: 74.99em) {
		padding-right: 0 !important;
	}
}

.toc-list {
	list-style: none;
	padding: 0;
	// The rail's top edge sits level with the page-actions button beside it.
	// Two values, because that button's row is not the same height at both
	// breakpoints: below `lg` the sidebar toggle joins it, which moves the
	// button down relative to the aside.
	margin: -1px 0 0;

	@media (min-width: 75em) {
		margin-top: -8px;
	}
}

// Below `lg` the aside starts lower than the reading column, so the whole
// block is pulled up to put the rail level with the page-actions button and
// the heading back beside the breadcrumb.
.toc-heading {
	display: block;
	margin-top: -60px;

	@media (min-width: 75em) {
		margin-top: 0;
	}
}

// A 1px rail, with the active item's marker drawn 2px wide over it. The marker
// is a shadow rather than a wider border, so the labels do not shift.
.toc-item {
	border-left: 1px solid var(--surreal-border-default);
	transition: border-color 200ms ease, box-shadow 200ms ease;

	&[data-active] {
		border-left-color: var(--docs-accent) !important;
		box-shadow: -1px 0 0 var(--docs-accent);
	}
}

.toc-link {
	display: block;
	// Room between the rail and the label so the text does not sit against it.
	padding: 6px 0;
	color: var(--mantine-color-slate-3);
	text-decoration: none;
	font-size: 15px;
	line-height: 1.375;
	transition: color 200ms ease;

	@include light {
		color: var(--mantine-color-slate-6);
	}

	&:hover,
	&[data-active] {
		color: var(--mantine-color-bright) !important;
	}
}